import {Observable} from "rxjs";

import {Contact} from "@app/core/contact/domain/contact";

export abstract class ContactRemote {
    abstract contact(contact: Contact, deliveryPointCode: number | undefined): Observable<void>;
}

